export default __webpack_public_path__ + "static/media/milestone 950.28abc51a.svg";